import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-400">
                凪光
              </span>
              <span className="ml-2 text-sm text-foreground-400">在线观看</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              凪光全集高清免费在线播放平台，支持PC端与手机端无需下载即可观看，画质清晰流畅，更新及时。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-categories" className="cursor-pointer">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  动画番剧
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  剧场版
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系方式</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@nagihikari.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line"></i>
                <span>www.nagihikari.com</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="https://bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 凪光在线观看. 本站所有内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            <span>|</span>
            <span>更新日期：2026-08-12</span>
          </div>
        </div>
      </div>
    </footer>
  );
}